module.exports = __webpack_public_path__ + "static/media/telegram.18fc0629.svg";